import React, { Component } from 'react';
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import 'react-widgets/dist/css/react-widgets.css';
import Loader from 'react-loader-spinner';
import OtpInput from 'react-otp-input';


class Signal extends Component {
  constructor() {
    super();

    this.state = {
      successResp: true,
      mobileOtp: '',
      gotOtp: false,
      mobileNumber: '',
      alreadyRegister: false,
      registeredMobNum: ''
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.fetchProjectDetailsApi()
      this.fetchSignalDataApi();
    }, 300);

    var signalComponent = this;
    document.addEventListener("projectChanged", function (event) {
      signalComponent.projectId = event.projectId;
      signalComponent.fetchProjectDetailsApi(event.projectId);
      document.getElementById("mob-num").value = '';
      signalComponent.state.gotOtp = false;
      signalComponent.setState(signalComponent.state)
      signalComponent.fetchSignalDataApi(event.projectId);
    });
  }

  fetchProjectDetailsApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var voiceController = this;
    $.ajax({
      url: "/api/project-details",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          if (res.result.deployed == false) {
            voiceController.notifyNotAdded("Oops!you have not deployed your project")
            var voiceInterval = setInterval(function () {
              clearTimeout(voiceInterval);
              window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
            }, 3000);
          }
        } else {
          voiceController.notifyNotAdded("Oops!you have not deployed your project")
          var voiceInterval = setInterval(function () {
            clearTimeout(voiceInterval);
            window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
          }, 3000);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  fetchSignalDataApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var signalComponent = this;

    $.ajax({
      url: "/api/social-properties",
      async: false,
      method: 'GET',
      data: {
        projectId: projectId,
        socialPlatform: 'SIGNAL',
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        document.getElementById("mob-num").value = '';
        signalComponent.state.gotOtp = false;
        if (res.success === true) {
          if (res.result.length > 0) {
            signalComponent.state.alreadyRegister = true;
            signalComponent.state.registeredMobNum = res.result[0].socialPropertyValue;
          } else {
            signalComponent.state.alreadyRegister = false;
          }
        } else {
          signalComponent.state.alreadyRegister = false;
        }
        signalComponent.setState(signalComponent.state);
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }


  notifyNotAdded(message) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;{message}</b>, {
      position: "top-center"
    });
  }

  handleMobileOtpChange = (otp) => {
    let mobileOtp = this.state.mobileOtp;
    mobileOtp = otp;
    this.setState({ mobileOtp })
  }

  handleChangeMobileNumber = (e) => {
    this.state.mobileNumber = e.target.value;
    this.setState(this.state);
  }

  notifyMobileNumWarn = (message) => {
    toast.dismiss();
    toast(<b><img src="./assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;{message}</b>, {
      position: "top-center"
    });
  }

  validateMobNum = () => {
    if (!this.state.mobileNumber) {
      this.notifyMobileNumWarn("Please enter your mobile number");
      return false;
    } else if (typeof this.state.mobileNumber !== "undefined") {
      if (!this.state.mobileNumber.match(/([0-9]){10}/)) {
        this.notifyMobileNumWarn("Please enter valid mobile number");
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  onClickRegister = () => {
    if (this.validateMobNum()) {
      var signalComponent = this;
      let data = {
        projectId: localStorage.getItem("currentProjectId"),
        phoneNumber: signalComponent.state.mobileNumber
      };
      $.ajax({
        url: "/api/register",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data,
        success: function (res) {
          if (res.success == true) {
            signalComponent.setState({ gotOtp: true });
          } else {
            signalComponent.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      });
    }
  }

  onClickVerifyOtp = () => {
    if (this.validateMobNum()) {
      var signalComponent = this;
      let data = {
        projectId: localStorage.getItem("currentProjectId"),
        otp: signalComponent.state.mobileOtp,
        phoneNumber: signalComponent.state.mobileNumber
      };
      $.ajax({
        url: "/api/verify-and-start",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data,
        success: function (res) {
          if (res.success == true) {
            signalComponent.notifySuccess("Mobile number registered successfully");
            signalComponent.fetchSignalDataApi();
            var signalComponent1 = setInterval(function () {
              clearTimeout(signalComponent1);
              signalComponent.setState({ alreadyRegister: true });
            }, 3000);
          } else {
            signalComponent.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      });
    }
  }

  notifyError = (message) => {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{message}</b>, {
      position: "top-center",
      color: "red"

    });
  }

  notifySuccess = (message) => {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{message}</b>, {
      position: "top-center",

    });
  }

  render() {
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: 'center' }}
        />

        <ToastContainer className="Toast-at-center" />

        <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">


          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />

          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <div className="container-fluid">

            <div className="card-body " style={{ padding: '2.5% 2.5% 2.5% 2.5%' }}>
              <div className="row" style={{ display: this.state.alreadyRegister ? 'none' : 'flex' }}>
                <div className="col-2"></div>
                <div className="col-8" style={{
                  padding: "70px", border: "1px solid #282A65",
                  borderRadius: "10px"
                }}>
                  <div>
                    Mobile Number : <input
                      id="mob-num"
                      style={{
                        border: '1px solid #D2D4DC',
                        borderRadius: '5px', width: "200px",
                        padding: '5px'
                      }}
                      onChange={this.handleChangeMobileNumber} />
                    <button className="btn action-button"
                      style={{ marginLeft: '15px' }}
                      onClick={this.onClickRegister}>
                      Register
                    </button>
                  </div>
                  <label>Remember to include your country code too, for example +919999988888</label>
                  <div style={{ display: 'flex', marginTop: '30px' }}>
                    <OtpInput
                      inputStyle={{
                        width: '2.7rem',
                        margin: '0 0.5rem',
                        fontSize: '1rem',
                        borderRadius: 4,
                        display: this.state.gotOtp ? 'block' : 'none'
                      }}
                      numInputs={6}
                      onChange={this.handleMobileOtpChange}
                    />
                    <button className="btn action-button"
                      style={{
                        marginLeft: '15px', display: this.state.gotOtp ? 'block' : 'none'
                      }}

                      onClick={this.onClickVerifyOtp}
                    >
                      Verify Otp
                    </button>
                  </div>
                </div>
              </div>
              <div className="row" style={{ display: this.state.alreadyRegister ? 'flex' : 'none' }}>
                <div className="col-2"></div>
                <div className="col-8" style={{
                  padding: "70px", border: "1px solid #282A65",
                  borderRadius: "10px"
                }}>
                  <div>
                    Registered mobile number : <input
                      disabled
                      value={this.state.registeredMobNum}
                      style={{
                        width: "100px",
                        padding: '5px'
                      }} />
                    <button className="btn action-button"
                      style={{ marginLeft: '100px' }}
                      onClick={() => this.setState({ alreadyRegister: false })}>
                      Re-Register
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
}

export default Signal;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/Signal.js